export enum EventDependency {
    EVENT_TRAFFIC = 'event-traffic',
    EVENT_TRAFFIC_HOUR = 'event-traffic-by-hour'
};
